$(document).ready(function () {  
    console.log("form2.js"); 
     
    /* ie9 placeholder */
    $('input, textarea').placeholder({customClass:'my-placeholder'});
    
    
    function inputdel_fn($this) {
        ///console.log('$this.val()', $this.val());
        var _noneDisable = !$this.prop("disabled");
        if( $this.val() != "" && _noneDisable){
            $this.siblings("button").css({display:"block"});
            $this.siblings("button").one("click", function(){
                $this.val("");
                $this.siblings("button").css({display:"none"});
            });
        }else{
            $this.siblings("button").css({display:"none"});
        }
    }
    $("body").on("focusout", ".input_del input", function(){
        inputdel_fn( $(this) );
    });
    $("body .input_del input").each(function($i){
        inputdel_fn( $(this) );
    });


    /* 선택박스 -- dropdownParent : 스타일링 추가를 위해.. */
    $(".select2Basic").select2({ width:'100%', minimumResultsForSearch: Infinity,}); 
    $(".select2Basic50").select2({ width:'100%', minimumResultsForSearch: Infinity, dropdownCssClass : 'select_50', });

    $(".select2Basic").on("select2-is-ready", function(){
        //$(".select-box").show();
        $(".page-search_box .search-area .select-box").show(); /* FAQ-01-01.html  */
        $(".MN000675 .board_write-wrap .form_table .select-box").show(); /* FAQ-01-02.html  */
    })
    $(".select2Basic").trigger("select2-is-ready");
    
    
    var footer_select2 = $(".select2Footer42"); 
    footer_select2.select2({ width:'100%', minimumResultsForSearch: Infinity, dropdownCssClass : 'selectFooter_42 js-select_scroll', }); 
    footer_select2.on("select2:open", function(){ console.log("열림")
        $(".js-select_scroll .select2-results__options").hide().addClass("mCustomScrollbar_cc");
        setTimeout(function(){ $(".mCustomScrollbar_cc").mCustomScrollbar().show(); },100);
    }); 
    footer_select2.on("select2:closing", function(){  console.log("닫침")
        $(".mCustomScrollbar_cc").mCustomScrollbar("destroy");
    }); 

    /* 윤리경영 팝업 & 비교하기 */
    $(".pop_custum_scroll_y").mCustomScrollbar();
    

    // 팝업 선택박스 index 높이기
    $(".select2Basic_pop").select2({   
        dropdownCssClass : 'increasedzindexclass_pop',
        minimumResultsForSearch: Infinity,
        width:"100%" 
    });
    $(".select2Basic_34pop").select2({   
        dropdownCssClass : 'increasedzindexclass_pop',
        minimumResultsForSearch: Infinity,
        width:"100%" 
    });
    
    /* datepicker(.datepicker-box) */
    $(".js-datepicker").datepicker({ 
        dateFormat: "yy-mm-dd", 
        showMonthAfterYear:true,
        //yearSuffix: "년",
        dayNames: ["S","M","T","W","T","F","S"]
    });
    $(".js-datepicker-yy_mm").monthPicker();
            
    /* 일반 툴팁 */
    $(".js-tooltip").tooltip({ 
        position: { 
            my: "center bottom-15",
            at: "center top",
            using: function( position, feedback ) {
                $( this ).css( position );
                $( "<div>" ).addClass( "arrow" ).addClass( feedback.vertical ).addClass( feedback.horizontal ).appendTo( this ); 
            }
        }
    });//.tooltip( "open" );

    
    /* 길설명 툴팁 */
    $(".js-tooltip_sendstate").tooltip({ 
        position: { 
            my: "center bottom-10",
            at: "center top",
            using: function( position, feedback ) {
                $( this ).css( position );
                var _dotL = feedback.target.left - position.left + 6; 
                $( "<div>" ).addClass( "arrow" ).addClass( feedback.vertical ).addClass( feedback.horizontal ).appendTo( this ).css({ left: _dotL });
            }
        },
        tooltipClass:"tooltip_big",
        items: "img, [data-geo], [title]",
        content: function() {
            var element = $( this );
            var selcet = $( this ).attr("data-geo");
            if ( element.is( "[data-geo]" ) ) {
                $(".ui-tooltip").css({"max-width":"500px;" });
                return $(selcet).html();
            }
            if ( element.is( "[title]" ) ) {
                return element.attr( "title" );
            }
            if ( element.is( "img" ) ) {
                return element.attr( "alt" );
            }
        }   
    });//.tooltip( "open" );       

});

